document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll("slider-component").forEach(function(slider){

      const progress =
        slider.querySelector(".luxury-carousel__progress-fill");

      if(!progress) return;

      function update(){

          const total =
            slider.totalPages || 1;

          const current =
            slider.currentPage || 1;

          const width =
            100/total;

          const left =
            (current-1)*width;

          progress.style.width =
            width + "%";

          progress.style.left =
            left + "%";

      }

      slider.addEventListener(
        "slideChanged",
        update
      );

      update();

  });

});